<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'0'"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div>
        <div class="text-left content-preview" v-html="node.content"></div>
      </div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Page Content"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updatePageContent(content)" />

    <VaColorPicker
      class="mb-4 panzoom-ignore"
      :title="'Background color'"
      mode="hexa"
      v-model="node.backgroundColor"></VaColorPicker>

    <v-select
      class="mb-4 panzoom-ignore"
      v-model="node.buttonLayout"
      :items="BUTTON_LAYOUT_OPTIONS"
      :label="'Action/Question layout'"
      hide-details></v-select>

    <v-text-field
      class="message-item__settings--cssclass panzoom-ignore"
      v-model="node.cssClass"
      :label="'Class'"
      persistent-placeholder
      :placeholder="''"></v-text-field>

    <!-- Progress Bar -->
    <v-checkbox
      class="mb-3"
      :label="'Enable progress bar'"
      :input-value="node.progressBar && node.progressBar.enabled"
      color="primary"
      hide-details="auto"
      @change="toggleProgressBar">
    </v-checkbox>

    <div v-if="node.progressBar && node.progressBar.enabled" class="ml-4 mb-4">
      <VaColorPicker
        class="mb-3 panzoom-ignore"
        :title="'Bar color'"
        mode="hexa"
            v-model="node.progressBar.color"></VaColorPicker>
      <v-text-field
        class="panzoom-ignore mb-3"
        v-model.number="node.progressBar.duration"
        :label="'Loading duration (ms)'"
        type="number"
        persistent-placeholder
        :placeholder="'3000'"></v-text-field>
      <v-text-field
        class="panzoom-ignore mb-3"
        v-model="node.progressBar.textAbove"
        :label="'Text above bar'"
        persistent-placeholder></v-text-field>
      <v-text-field
        class="panzoom-ignore"
        v-model="node.progressBar.textBelow"
        :label="'Text below bar'"
        persistent-placeholder></v-text-field>
    </div>

    <!-- Checking Element -->
    <v-checkbox
      class="mb-3"
      :label="'Enable checking element'"
      :input-value="node.checkingElement && node.checkingElement.enabled"
      color="primary"
      hide-details="auto"
      @change="toggleCheckingElement">
    </v-checkbox>

    <div v-if="node.checkingElement && node.checkingElement.enabled" class="ml-4 mb-4">
      <VaColorPicker
        class="mb-3 panzoom-ignore"
        :title="'Text color'"
        mode="hexa"
            v-model="node.checkingElement.textColor"></VaColorPicker>
      <v-checkbox
        class="mb-3"
        :label="'Auto-advance after all items shown'"
        v-model="node.checkingElement.autoAdvance"
        color="primary"
        hide-details="auto">
      </v-checkbox>
      <v-text-field
        class="panzoom-ignore mb-3"
        v-model.number="node.checkingElement.timeBetweenItems"
        :label="'Time between items (ms)'"
        type="number"
        persistent-placeholder
        :placeholder="'700'"></v-text-field>
      <v-text-field
        class="panzoom-ignore mb-3"
        v-model.number="node.checkingElement.checkSize"
        :label="'Check icon size (px)'"
        type="number"
        persistent-placeholder
        :placeholder="'16'"></v-text-field>
      <v-select
        class="mb-3 panzoom-ignore"
        v-model="node.checkingElement.checkIcon"
        :items="CHECKING_ICON_OPTIONS"
        :label="'Check icon'"
        hide-details></v-select>
      <VaColorPicker
        v-if="node.checkingElement.checkIcon !== 'none'"
        class="mb-3 panzoom-ignore"
        :title="'Icon color'"
        mode="hexa"
        v-model="node.checkingElement.checkIconColor"></VaColorPicker>
      <va-array-input
        class="panzoom-ignore"
        v-slot="props"
        v-model="node.checkingElement.items"
        :label="'Checking items'"
        :add-button-text="'Add item'"
        :block-label="'Item'"
        column-layout-without-drag>
        <v-btn
          class="d-flex mt-2"
          text
          outlined
          small
          @click="toggleCheckingItemEditor(props.index)">
          {{ isCheckingItemEditorOpen(props.index) ? 'Close Editor' : 'Content Edit' }}
        </v-btn>
        <div v-if="!isCheckingItemEditorOpen(props.index) && node.checkingElement.items[props.index].text" class="mt-1">
          <div class="content-preview-label">Content preview</div>
          <div class="text-left content-preview" style="color: #000000" v-html="node.checkingElement.items[props.index].text"></div>
        </div>
        <va-tinymce-input
          v-if="isCheckingItemEditorOpen(props.index)"
          class="mt-2 w-full"
          :current-content="node.checkingElement.items[props.index].text"
          :editor-height="80"
          text-only
          title="Text"
          auto-resize
          @update="content => updateCheckingItemText(props.index, content)" />
        <div class="mb-4"></div>
      </va-array-input>
    </div>

    <v-checkbox
      v-if="$can('view', 'live chat ringba parameters')"
      class="mb-3"
      :label="'Ringba replace script'"
      v-model="node.hasRingbaScript"
      color="primary"
      hide-details="auto"
      @change="hasRingbaScriptChange">
    </v-checkbox>

    <code-input
      v-if="node.hasRingbaScript"
      class="panzoom-ignore ringba-script-input mb-3"
      v-model="node.ringbaScript"
      :title="'Ringba script'"></code-input>
  </div>
</template>

<script>
  import CodeInput from "@/components/custom/CodeInput";
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import { BUTTON_LAYOUT_OPTIONS, CHECKING_ICON_OPTIONS } from "./constant";

  /* eslint-disable */
  export default {
    name: "MultiStepFormPage",
    components: { CodeInput, VaColorPicker },
    props: {
      node: {
        type: Object,
        required: true,
      },
      formTextColor: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        BUTTON_LAYOUT_OPTIONS,
        CHECKING_ICON_OPTIONS,
        showEditor: !this.node?.content,
        checkingItemEditors: {},
      };
    },
    beforeMount() {
      if (!this.node.image) {
        this.$set(this.node, "image", { imageID: "", imageURL: "" });
      }
      if (!this.node.buttonLayout) {
        this.$set(this.node, "buttonLayout", "vertical");
      }
      if (!this.node.progressBar) {
        this.$set(this.node, "progressBar", {
          enabled: false,
          color: "#007bffFF",
          duration: 3000,
          textAbove: "",
          textBelow: "",
        });
      }
      if (!this.node.checkingElement) {
        this.$set(this.node, "checkingElement", {
          enabled: false,
          items: [],
          textColor: "",
          autoAdvance: true,
          timeBetweenItems: 700,
          checkSize: 16,
          checkIcon: "✔",
        });
      }
      if (this.node.checkingElement && !this.node.checkingElement.checkSize) {
        this.$set(this.node.checkingElement, "checkSize", 16);
      }
      if (this.node.checkingElement && !this.node.checkingElement.checkIcon) {
        this.$set(this.node.checkingElement, "checkIcon", "✔");
      }
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      hasRingbaScriptChange(val) {
        if (!val) {
          this.node.ringbaScript = "";
        }
      },
      updatePageContent(content) {
        this.node.content = content;
      },
      toggleProgressBar(val) {
        this.$set(this.node.progressBar, "enabled", !!val);
      },
      isCheckingItemEditorOpen(index) {
        if (this.checkingItemEditors[index] !== undefined) {
          return this.checkingItemEditors[index];
        }
        return !this.node.checkingElement.items[index].text;
      },
      toggleCheckingItemEditor(index) {
        this.$set(this.checkingItemEditors, index, !this.isCheckingItemEditorOpen(index));
      },
      updateCheckingItemText(index, content) {
        const item = this.node.checkingElement.items[index];
        item.text = content;
        this.$set(this.node.checkingElement.items, index, { ...item });
      },
      toggleCheckingElement(val) {
        this.$set(this.node.checkingElement, "enabled", !!val);
        if (val && !this.node.checkingElement.textColor && this.formTextColor) {
          this.$set(this.node.checkingElement, "textColor", this.formTextColor);
        }
        if (val && !this.node.checkingElement.checkIconColor && this.formTextColor) {
          this.$set(this.node.checkingElement, "checkIconColor", this.formTextColor);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ringba-script-input {
    text-align: left;
  }
</style>
